var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "debugPage"
  }, [_c('div', {
    staticClass: "contentLeft"
  }, [_c('div', {
    staticClass: "videoBox"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "14px",
      "font-size": "16px",
      "font-weight": "bold",
      "color": "#33ab4f"
    }
  }, [_vm._v("RtilCode:" + _vm._s(_vm.changeRtilCode))]), _c('div', {
    ref: "videoTest",
    staticClass: "local_stream"
  }), _c('div', {
    staticClass: "iconListBox"
  }, [_c('span', {
    staticClass: "contentClass"
  }, [!_vm.mute ? _c('i', {
    staticClass: "voiceIcon iconfont icon-speakeron pointer",
    on: {
      "click": function ($event) {
        return _vm.setAudio('mute');
      }
    }
  }) : _c('i', {
    staticClass: "iconfont icon-speakeroff pointer",
    on: {
      "click": function ($event) {
        return _vm.setAudio('unmute');
      }
    }
  }), _c('el-slider', {
    staticClass: "voiceSlider",
    attrs: {
      "min": 0,
      "max": 100
    },
    on: {
      "input": _vm.setVideoAudio
    },
    model: {
      value: _vm.voiceVal,
      callback: function ($$v) {
        _vm.voiceVal = $$v;
      },
      expression: "voiceVal"
    }
  })], 1)])])])]), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('debugPage.title')))]), _c('div', {
    staticClass: "partyCode"
  }, [_c('span', {
    staticClass: "commonSpan"
  }, [_vm._v(_vm._s(_vm.$t('debugPage.partyCode')))]), _c('el-input', {
    staticClass: "commonInput",
    attrs: {
      "clearable": ""
    },
    model: {
      value: _vm.partyCode,
      callback: function ($$v) {
        _vm.partyCode = $$v;
      },
      expression: "partyCode"
    }
  }), _vm.manageRtilCode.length == 0 ? _c('el-button', {
    staticClass: "join",
    attrs: {
      "loading": _vm.joinLoading
    },
    on: {
      "click": _vm.join
    }
  }, [_vm._v(_vm._s(_vm.$t('debugPage.join')))]) : _c('el-button', {
    staticClass: "leave",
    on: {
      "click": _vm.leave
    }
  }, [_vm._v(_vm._s(_vm.$t('debugPage.leave')))])], 1), _c('el-divider', {
    staticClass: "settingDivider"
  }), _c('div', {
    staticClass: "notes"
  }, [_vm._v(_vm._s(_vm.$t('debugPage.notes')))]), _c('div', {
    staticClass: "selectPlayContent"
  }, _vm._l(_vm.realManageRtilCode, function (item, index) {
    return _c('el-radio-group', {
      key: index,
      on: {
        "input": _vm.subscribeRtil
      },
      model: {
        value: _vm.rtilCode,
        callback: function ($$v) {
          _vm.rtilCode = $$v;
        },
        expression: "rtilCode"
      }
    }, [_c('el-radio-button', {
      attrs: {
        "label": item,
        "disabled": item === _vm.hostRtilCode
      }
    }, [_c('span', [_vm._v(_vm._s(item === _vm.hostRtilCode ? 'Me:' : 'Broadcaster:') + _vm._s(item))])])], 1);
  }), 1)], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };